import React from 'react'

const ManageReports = () => {
  return (
    <div>
      ManageReports
    </div>
  )
}

export default ManageReports
